import LegalPage from './LegalPage';

export default function TermsOfService() {
  return (
    <LegalPage
      pageKey="terms"
      testId="terms-of-service"
      extraFooterLinks={[
        { to: '/privacy', labelKey: 'privacy' },
        { to: '/sms-compliance', labelKey: 'smsCompliance' },
      ]}
    />
  );
}
